
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { MailboxInterface, MailboxRepositoryInterface, MailboxUserInterface } from '@/services/Mailbox/interfaces';
import { ServerInterface } from '@/services/Server/Interfaces';
import { Website } from '@/services/Website/interfaces';
import {
  PasswordValidationCallbacks,
  RealNameValidationCallbacks,
} from '@/services/misc/functions/ValidationFunctions';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'mailboxRepository'
  ]
})
export default class EditMailboxUserDialog extends Vue {
  public isValid: boolean = true;
  public visible: boolean = true;
  public mailboxRepository!: MailboxRepositoryInterface;
  private loadingPassword: boolean = false;

  @Prop() public data: {
    mailbox: MailboxInterface,
    user: MailboxUserInterface,
    server: ServerInterface,
    website: Website,
  };

  public userStatuses: string[] = [
    'CREATING',
    'CREATED',
    'UPDATING',
    'ERROR',
  ];

  public password: string = '';
  public passwordRules: { (v: string): boolean | string; }[] = [
    ...PasswordValidationCallbacks,
  ];
  public realNameRules: { (v: string): boolean | string; }[] = [
    ...RealNameValidationCallbacks,
  ];
  public showPassword: boolean = false;

  private async togglePasswordVisibility(): Promise<void> {
    this.showPassword = !this.showPassword;

    if (this.showPassword && !this.password && this.data?.user?.id) {
      try {
        this.loadingPassword = true;
        this.password = await this.mailboxRepository.getUserDecryptedPassword(this.data.user.id);
      } catch (err) {
        this.$errorDialog.show(err.response?.data?.message || err.message || 'Failed to load password');
        this.showPassword = false;
      } finally {
        this.loadingPassword = false;
      }
    }
  }


  public set aliases(aliases: string[]) {
    this.data.user.aliases = aliases.map((alias) => ({ id: -1, alias }));
  }

  public get aliases(): string[] {
    return this.data.user.aliases.map((mailboxAlias) => mailboxAlias.alias);
  }

  public set forwards(forwards: string[]) {
    this.data.user.forwards = forwards.map((email) => ({ id: -1, email }));
  }

  public get forwards(): string[] {
    return this.data.user.forwards.map((forward) => forward.email);
  }

  public validateAliases(): boolean[] {
    return [
      this.aliasesAreValid() || 'Aliases must be valid email addresses',
    ];
  }

  public aliasesAreValid(): boolean {
    return !this.aliases ||
      !this.aliases.length ||
      this.aliases.every((val) => val && /^(?:|[A-Za-z0-9.-]{3,})@[A-Za-z0-9.-]{3,}\.[A-Za-z.-]{2,3}$/.test(val));
  }

  private saveChanges(): void {
    this.data.user.password = this.password;
    this.$emit('edit', this.data.user);
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
